import {Component, OnInit} from '@angular/core';
import {DataService} from "../../services/data.service";
import {UserProfileService} from "../../services/user-profile.service";
import {FrontEndService} from "../../services/front-end.service";
import {Transition} from '@uirouter/angular';
import html2pdf from '../../../../node_modules/html2pdf.js';

@Component({
    selector: 'app-view-user-profile-details',
    templateUrl: './view-user-profile-details.component.html',
    styleUrls: ['./view-user-profile-details.component.scss']
})
export class ViewUserProfileDetailsComponent implements OnInit {

    fullScreenLoader = false;
    profileId = 0;
    userProfile = {};

    pdfOptions = {
        margin: 0.5,
        filename: 'User Profile.pdf',
        image: { type: 'jpg', quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
        letterRendering: true,
        useCORS: true
    };

    constructor(
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private userProfileService: UserProfileService,
        private transition: Transition,
    ) { }

    ngOnInit() {
        if (this.transition.params().user_id != null) {
            this.profileId = this.transition.params().user_id;
            this.getProfileDetails();
        }
    }

    getProfileDetails() {
        this.fullScreenLoader = true;
        this.userProfileService.getProfileDetails(this.profileId, (response) => {
           if (response.status) {
                this.userProfile = response.data;
                if (this.userProfile["image"]) {
                    this.front_end_service.convertImageUrlToBase64(this.userProfile["image"], (base64Image) => {
                        this.userProfile["image"] = base64Image;
                    });
                }
           } else {
               this.front_end_service.back();
           }
           this.fullScreenLoader = false;
        });
    }

    deleteProfile() {
        this.front_end_service.confirmAlert('confirm', 'delete_profile_confirmation', 'warning', (result) => {
            if (result.value) {
                this.fullScreenLoader = true;
                this.userProfileService.deleteProfile(this.profileId, (response) => {
                    if (response.status) {
                        this.front_end_service.addToast(
                            "Success",
                            "profile_deleted_successfully",
                            "success"
                        );
                        this.front_end_service.back();
                    }
                    this.fullScreenLoader = false
                });
            }
        });
    }

    exportPdf() {
        this.fullScreenLoader = true;
        const element = document.getElementById('user-profile-pdf');
        html2pdf().set(this.pdfOptions).from(element).save()
            .then(() => {
                this.fullScreenLoader = false;
            });
    }
}
